/* eslint-disable import/prefer-default-export */
import type { RootState } from '@src/store/reduxstore';

export const allBotAccountsSelector = (state: RootState) =>
  state.allBotAccounts.botAccounts;
